<template>
  <div class="identityAndAccessManagementResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="listCurrentCompanyAccounts(companyId)"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          search
          v-model="iamUserName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:identityAndAccessManagementResource:page'
          ]"
          @click="conditionSearch"
          >{{ $t("alarms.common.search") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../../utils/cookieUtil.js";
import TableIdentityAndAccessManagementResource from "../iam/TableIdentityAndAccessManagementResource";
var tableIdentityAndAccessManagementResource = TableIdentityAndAccessManagementResource;
export default {
  name: "IdentityAndAccessManagementResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accounts: [],
      accountIds: [],
      iamUserName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
    this.listCurrentCompanyAccounts(this.company);
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
          this.companyId = this.companyList[0].id;
        });
    },
    // 按公司搜索
    conditionSearch: function() {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountIds", this.accountIds);
      eventBus.$emit("iamUserName", this.iamUserName);

      tableIdentityAndAccessManagementResource.methods.showAll();
    },
    // 按用户名称查询
    searchUserName: function() {
      eventBus.$emit("iamUserName", this.iamUserName);
      tableIdentityAndAccessManagementResource.methods.showAll();
    },
    // 列出当前公司下的所有账号
    listCurrentCompanyAccounts: function(companyId) {
      this.$api.account
        .queryAccountListByCompanyIdAndCloudType({
          companyId: companyId,
          cloudPlatformType: 0
        })
        .then(res => {
          this.accounts = res.data;
        });
    }
  }
};
</script>
<style scoped>
.identityAndAccessManagementResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/iam/IdentityAndAccessManagementResourceSearch.vue